module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"common":{"link":{"giveFeedback":"Give Feedback","legal":"Legal","privacyPolicy":"Privacy Policy","productRecall":"Product Recall","termsOfUse":"Terms of Use"},"note":{"copyright":"© {year} OneChart, Inc. All rights reserved."},"title":{"giveFeedback":"Give Feedback"}}}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./src/core/components/Footer.locale.json
// module id = 366
// module chunks = 171